import { render } from "./SearchForm.vue?vue&type=template&id=11144170"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"
script.render = render

export default script